import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "edit-drop",
  "use": "edit-drop-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"edit-drop\">\n<path d=\"M12.7682 14.0781L16.3166 9.82009C16.588 9.49443 16.3564 9 15.9325 9H8.06752C7.6436 9 7.41202 9.49443 7.68341 9.82009L11.2318 14.0781C11.6316 14.5579 12.3684 14.5579 12.7682 14.0781Z\" fill=\"#323232\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol